import React from "react";
import Logo from '../../assets/image/MainLogo.svg';
import MyPendingSideLogo from '../../assets/image/MyPendingSideLogo.svg';
import TimesheetSideLogoActive from '../../assets/image/TimesheetSideLogoActive.svg';
import SideBottomImg from '../../assets/image/SideBottomImg.svg';
import LeftPanelClase from '../../assets/image/LeftPanelClose.svg';
import LeftPanelOpen from '../../assets/image/left_panel_open.svg';
import BusinessCenterActive from '../../assets/image/business_center.svg';
import Person from '../../assets/image/person.svg';
import BusinessCenter from '../../assets/image/business_center_non_active.svg';
import PersonActive from '../../assets/image/person_active.svg';
import Sell from '../../assets/image/sell.svg';
import List from '../../assets/image/format_list_bulleted.svg';
import Groups from '../../assets/image/groups.svg';
import SupervisorAccount from '../../assets/image/supervisor_account.svg';
import Filter from '../../assets/image/filter_alt.svg';
import Filtered from '../../assets/image/filteredIcon.svg';
import Upload from '../../assets/image/upgrade.svg';
import Close from '../../assets/image/close.svg';
import AddPlus from '../../assets/image/plus_icon.svg';
import ExcelFile from '../../assets/image/excel-file.svg';
import GroupBy from '../../assets/image/tune.svg';
import LeftArrow from '../../assets/image/LeftArrow.svg';
import RightArrow from '../../assets/image/RightArrow.svg';
import UserPic from '../../assets/image/user_pic.svg';
import Menu from '../../assets/image/menu.svg';
import MoreIcon from '../../assets/image/more_horiz.svg';
import FilterMob from '../../assets/image/filter_alt_mob.svg';
import GroupByMob from '../../assets/image/tune_mob.svg';
import SearchMob from '../../assets/image/search_mob.svg';
import MenuMob from '../../assets/image/menu_mob.svg';
import ExpandDown from '../../assets/image/expand_more.svg';
import NextIcon from '../../assets/image/nextIcon.svg'
import PrevIcon from '../../assets/image/PrevIcon.svg';
import DoubleLeftIcon from '../../assets/image/keyboard_double_arrow_left.svg';
import DoubleRightIcon from '../../assets/image/keyboard_double_arrow_right.svg';
import Three_dots from '../../assets/image/three_dots.svg';
import Login_icon from '../../assets/image/logout.svg';
import flaz_logo from '../../assets/image/flaz_logo.svg';
import flaz_logonew from '../../assets/image/flaz_logonew.svg';
import flaz_logonewsmall from '../../assets/image/flaz_logosmallnew.svg';

import flaz_logo_small from '../../assets/image/flaz_logo_small.svg';
import flaz_logo_login from '../../assets/image/flaz_logo_login.svg';
import JobApplicationSideLogo from '../../assets/image/job_application.svg';
import JobApplicationSideLogoActive from '../../assets/image/job_application_active.svg';
import Flazlogo from "../../assets/svg/Group 30836.svg"

import SelectUploadFile from '../../assets/image/select-upload.png';
import UploadFile from '../../assets/image/upload.png';
import SelectManually from '../../assets/image/select-manually.png';
import Manually from '../../assets/image/manually.png';

import SwitchYes from '../../assets/image/yes-icon.png';
import SwitchNo from '../../assets/image/no-icon.png';
import FileUpload from '../../assets/image/uploadfile.png';
import Delete from '../../assets/image/delete.svg';
import Drag from '../../assets/image/drag.png';
import Settings from '../../assets/image/settings.svg';
import Company from '../../assets/image/company.svg';
import Language from '../../assets/image/Language.svg';
import LanguageLevel from '../../assets/image/languagelevel.svg';
import Lookup from '../../assets/image/lookup.svg';
import Client from '../../assets/image/client.svg';
import Recruiter from '../../assets/image/recruiter.svg';
import RightArrowcollapse from '../../assets/svg/rightcollapse.svg';
import LeftArrowcollapse from '../../assets/svg/leftcollapse.svg';
import DeleteIcon from '../../assets/svg/delete.svg';
import AddIcon from '../../assets/svg/addIcon.svg';
import ArrowDropUpIcon from '../../assets/svg/arrowDropUpIcon.svg'
import ArrowDropDownIcon from '../../assets/svg/arrowDropDownIcon.svg'
import createAccountbg from "../../assets/svg/createAccountbg.svg"
import mail from "../../assets/svg/mailcreate (1).svg"
import personcreate from "../../assets/svg/mailcreate (2).svg"
import emailIcon from "../../assets/svg/uiw_mail-o (2).svg"
import Apartment from "../../assets/svg/apartment.svg";
import Lockpassword from "../../assets/svg/lock.svg"
import Flaz_logo from "../../assets/svg/Group 30836 (1).svg"
import For_RMS from "../../assets/svg/icon-park-outline_people-search.svg"
import For_HRMS from "../../assets/svg/clarity_group-line.svg";
import For_Appmonitor from "../../assets/svg/icon-park-outline_more-app.svg";
import For_Payroll from "../../assets/svg/fluent_clock-bill-16-regular.svg";
import LineProduct from "../../assets/svg/Line 84 (1).svg";
import SideArrow from "../../assets/svg/chevron_forward.svg";
import passwordvisibleoff from "../../assets/svg/visibility_off.svg"
import passwordvisible from "../../assets/svg/visibility.svg";
import successTick from "../../assets/svg/check_circle.svg"
import home from "../../assets/svg/home.svg"
import profiledetails from "../../assets/svg/person.svg";
import profilechangepassword from "../../assets/svg/lock_person.svg"
import profilelogout from "../../assets/svg/move_item.svg"
import profiledetailsunslect from "../../assets/svg/person (1).svg"
import profilechangepasswordunslect from "../../assets/svg/lock_person (1).svg"
import profilelogoutunslect from "../../assets/svg/move_item (1).svg"
import logouticon from "../../assets/svg/move_item (2).svg"
import removeuser from "../../assets/svg/person (2).svg"
import close from "../../assets/svg/close.svg"
import saveicon from "../../assets/svg/check.svg"
import editicon from "../../assets/svg/edit_square.svg"
import Arrownext from "../../assets/svg/arrow_forward.svg"
import subscription from "../../assets/svg/add_shopping_cart.svg"
import updateicon from "../../assets/svg/update.svg";
import settingicon from "../../assets/svg/settings.svg";
import groupicon from "../../assets/svg/group.svg";
import idcardicon from "../../assets/svg/id_card.svg";
import deletgroup from "../../assets/svg/deletegroup.svg"
import deleteMember from "../../assets/svg/deletemember.svg";
import bill from "../../assets/svg/billpayment.svg";
import downloadbill from "../../assets/svg/downloadinvoice.svg";
import downloadicon from "../../assets/svg/downloadicon.svg";
import SelectUploadFile1 from "../../assets/svg/SelectUploadFile.svg"
import billnotselect from "../../assets/svg/receipt_long.svg"
import teamsWhite from "../../assets/image/teamsWhite.svg";
import teamsActive from "../../assets/image/teamsActive.svg";
import downloablue from "../../assets/image/downloadIconBlue.svg";
import flazlogologin from '../../assets/svg/flaz_logo_login.svg';
import flagIcon from '../../assets/svg/FlagIcon.svg';
import phoneIcon from '../../assets/svg/phoneIcon.svg';
import closecopy from '../../assets/image/close copy.svg';
import unauthorize from '../../assets/svg/user-icon.svg';
import jsonFile from "../../assets/image/jsonFile.png"

const CommonIcon = ({ fileName }) => {
    if (fileName) {
        switch (fileName) {
            case "MainLogo":
                return <img src={Logo} alt="" className="properties-img" />;
            case "jsonFile":
                return <img src={jsonFile} alt="" className="json" width={"30px"} height={"30px"}/>;
            case "unauthorize":
                return <img src={unauthorize} alt="" className="properties-img" />;

            case "teamsActive":
                return <img src={teamsActive} alt=""  />;
            case "downloadBlue":
                return <img src={downloablue} alt="" className="properties-img" />;
            case "teams":
                return <img src={teamsWhite} alt=""  />;

            case "MyPendingSideLogo":
                return <img src={MyPendingSideLogo} alt="" className="properties-img" />;
            case "TimesheetSideLogoActive":
                return <img src={TimesheetSideLogoActive} alt="" className="properties-img" />;
            case "SideBottomImg":
                return <img src={SideBottomImg} alt="" className="bottom-img" />;
            case "SideBottomMobImg":
                return <img src={SideBottomImg} alt="" className="bottom-img-mob" />;
            case "LeftPanelClase":
                return <img src={LeftPanelClase} alt="" className="properties-img" />;
            case "LeftPanelOpen":
                return <img src={LeftPanelOpen} alt="" className="properties-img" />;
            case "BusinessCenter":
                return <img src={BusinessCenter} alt="" width="17px" className="properties-img" />;
            case "Person":
                return <img src={Person} alt="" width="20px" height={"18px"} />;
            case "JobApplicationSideLogo":
                return <img src={JobApplicationSideLogo} alt="" width="20px"  />;
            case "Sell":
                return <img src={Sell} alt="" className="properties-img" />;
            case "List":
                return <img src={List} alt="" className="properties-img" />;
            case "Groups":
                return <img src={Groups} alt="" />;
            case "SupervisorAccount":
                return <img src={SupervisorAccount} alt="" className="properties-img" />;
            case "Filter":
                return <img src={Filter} alt="" className="properties-img" />;
            case "Filtered":
                return <img src={Filtered} width={"16px"} height={"15px"} alt="" className="properties-img" />;
            case "Filter1":
                return <img src={Filter} alt="" className="" />;
            case "Filtered1":
                return <img src={Filtered} width={"16px"} height={"15px"} alt="" className="" />;
            case "Upload":
                return <img src={Upload} alt="" className="properties-img" />;
            case "Close":
                return <img src={Close} alt="" className="properties-img" />;
            case "CloseSmall":
                return <img src={Close} alt="" width={9} height={8} className="close-icon" />;
            case "CloseSmallwhite":
                return <img src={closecopy} alt="" width={9} height={8} className="close-icon" />;
            case "AddPlus":
                return <img src={AddPlus} alt="" className="properties-img" />;
            case "AddPlus1":
                return <img src={AddPlus} alt="" className="properties-img1" />;
            case "ExcelFile":
                return <img src={ExcelFile} alt="" className="properties-img" />;
            case "GroupBy":
                return <img src={GroupBy} alt="" className="properties-img" />;
            case "LeftArrowIcon":
                return <img src={LeftArrow} alt="" />;
            case "RightArrowIcon":
                return <img src={RightArrow} alt="" />;
            case "UserPic":
                return <img src={UserPic} alt="" />;
            case "PersonActive":
                return <img src={PersonActive} alt="" width="20px" height={"18px"}/>;
            case "BusinessCenterActive":
                return <img src={BusinessCenterActive} alt="" width="17px" />;
            case "JobApplicationSideLogoActive":
                return <img src={JobApplicationSideLogoActive} alt="" width="20px" />;
            case "Menu":
                return <img className="menu-svg" src={Menu} alt="" />;
            case "MoreIcon":
                return <img src={MoreIcon} alt="" width="20px" height="20px" />;
            case "FilterMob":
                return <img src={FilterMob} alt="" width="20px" height="20px" />;
            case "GroupByMob":
                return <img src={GroupByMob} alt="" width="20px" height="20px" />;
            case "SearchMob":
                return <img src={SearchMob} alt="" width="20px" height="20px" />;
            case "AddBottom":
                return <img src={AddPlus} alt="" height="42px" className="properties-img" />;
            case "MenuMob":
                return <img src={MenuMob} alt="" height="12px" width="18px" />;
            case "ExpandDown":
                return <img src={ExpandDown} alt="" className="properties-img" />;
            case "NextIcon":
                return <img src={NextIcon} alt="" className="properties-img" />;
            case "PrevIcon":
                return <img src={PrevIcon} alt="" className="properties-img" />;
            case "DoubleLeftIcon":
                return <img src={DoubleLeftIcon} alt="" className="properties-img" />;
            case "DoubleRightIcon":
                return <img src={DoubleRightIcon} alt="" className="properties-img" />;
            case "Three_dots":
                return <img src={Three_dots} alt="" className="properties-img" />;
            case "Login_icon":
                return <img src={Login_icon} alt="" width="40px" height="40px" />;
            case "flaz_logo":
                return <img src={flaz_logonew} alt="" className="properties-img" />;
            case "flaz_logo_small":
                return <img src={flaz_logonewsmall} alt="" className="properties-img" />;
            case "flaz_logo_login":
                return <img src={flaz_logo_login} alt="" className="properties-img login-logo" />;
            case "SelectUploadFile":
                return <img src={SelectUploadFile} alt="" className="properties-img" />;
            case "UploadFile":
                return <img src={UploadFile} alt="" className="properties-img" />;
            case "SelectManually":
                return <img src={SelectManually} alt="" className="properties-img" />;
            case "Manually":
                return <img src={Manually} alt="" className="properties-img" />;
            case "SwitchYes":
                return <img src={SwitchYes} alt="" className="properties-img" />;
            case "SwitchNo":
                return <img src={SwitchNo} alt="" className="properties-img" />;
            case "FileUpload":
                return <img src={FileUpload} alt="" className="properties-img" />;
            case "F":
                return <img src={Delete} width="10px" height="18px" alt="" className="properties-img mr-6" />;
            case "Drag":
                return <img src={Drag} alt="" className="properties-img" />;
            case 'Settings':
                return <img src={Settings} alt="" width="20" style={{ color: "white" }} />;
            case 'Company':
                return <img src={Company} alt="" width="18px" className="properties-img" />;
            case 'Language':
                return <img src={Language} alt="" width="18px" className="properties-img" />;
            case 'LanguageLevel':
                return <img src={LanguageLevel} alt="" width="18px" className="properties-img" />;
            case 'Client':
                return <img src={Client} alt="" width="18px" className="properties-img" />;
            case 'Recruiter':
                return <img src={Recruiter} alt="" width="18px" className="properties-img" />;
            case 'Lookup':
                return <img src={Lookup} alt="" width="18px" className="properties-img" />;
            case "RightArrowcollapse":
                return <img src={RightArrowcollapse} alt="" />;
            case "LeftArrowcollapse":
                return <img src={LeftArrowcollapse} alt="" />;
            case "DeleteIcon":
                return <img src={DeleteIcon} alt="" />;
            case "AddIcon":
                return <img src={AddIcon} alt="" />;
            case "ArrowUpIcon":
                return <img src={ArrowDropUpIcon} alt="" />;
            case "ArrowDownIcon":
                return <img src={ArrowDropDownIcon} alt="" />;
            case "CreateAccountBg":
                return <img src={createAccountbg} alt="" />
            case "mail":
                return <img src={mail} alt="" />
            case "personcreate":
                return <img src={personcreate} alt="" />
            case "Flazlogo":
                return <img src={Flaz_logo} alt="" />
            case "FlazlogoLogin":
                return <img src={flazlogologin} alt="" />
            case "emailIcon":
                return <img src={emailIcon} alt="" />
            case "Apartment":
                return <img src={Apartment} alt="" />
            case "Lockpassword":
                return <img src={Lockpassword} alt="" />
            case "flagicon":
                return <img src={flagIcon} alt="" />
            case "phoneicon":
                return <img src={phoneIcon} style={{marginLeft:'5px'}} alt="" />
            case "RMS":
                return <img src={For_RMS} alt="" />
            case "HRMS":
                return <img src={For_HRMS} alt="" />
            case "Appmonitor":
                return <img src={For_Appmonitor} alt="" />
            case "payroll":
                return <img src={For_Payroll} alt="" />
            case "LineProduct":
                return <img src={LineProduct} alt="" />
            case "SideArrow":
                return <img src={SideArrow} alt="" />
            case "passwordvisibleoff":
                return <img src={passwordvisibleoff} alt="" />
            case "passwordvisible":
                return <img src={passwordvisible} alt="" />
            case "successTick":
                return <img src={successTick} alt="" />
            case "home":
                return <img src={home} alt="" width={"20px"} height={"20px"} style={{marginTop:'-1px'}} />
            case "profiledetails":
                return <img src={profiledetails} alt="" />
            case "profilelogout":
                return <img src={profilelogout} alt="" />
            case "profilechangepassword":
                return <img src={profilechangepassword} alt="" />
            case "profiledetailsunslect":
                return <img src={profiledetailsunslect} alt="" />
            case "profilelogoutunslect":
                return <img src={profilelogoutunslect} alt="" />
            case "profilechangepasswordunslect":
                return <img src={profilechangepasswordunslect} alt="" />
            case "logouticon":
                return <img src={logouticon} alt="" />
            case "removeuser":
                return <img src={removeuser} alt="" />
            case "close":
                return <img src={close} alt="" />;
            case "saveicon":
                return <img src={saveicon} alt="" />;
            case "editicon":
                return <img src={editicon} alt="" />;
            case "Arrownext":
                return <img src={Arrownext} alt="" />;
            case "subscription":
                return <img src={subscription} alt="" />;
            case "idcardicon":
                return <img src={idcardicon} alt="" />;
            case "idcardicon1":
                return <img src={idcardicon} alt="" style={{marginTop:'1px'}} />;
            case "groupicon":
                return <img src={groupicon} alt="" />;
            case "settingicon":
                return <img src={settingicon} alt="" />;
            case "updateicon":
                return <img src={updateicon} alt="" />;
            case "deletegroup":
                return <img src={deletgroup} alt="" />;
            case "deletemember":
                return <img src={deleteMember} alt="" />;
            case "bill":
                return <img src={bill} width={"20px"} height={"20px"} alt="" />;
            case "downloadbill":
                return <img src={downloadbill} alt="" />;
            case "downloadicon":
                return <img src={downloadicon} alt="" />;
            case "SelectUploadFile1":
                return <img src={SelectUploadFile1} alt="" />;
            case "billnotselect":
                return <img src={billnotselect} alt="" width={"20px"} height={"20px"}/>;


            default:
                return <></>
        }
    } else {
        // return <img src={blankFile} alt="" />;
    }
};

export default CommonIcon;